import dayjs from '../date';

export function dayDiffFromNow(dateString: string, nowString?: string) {
  const date = dayjs(dateString);
  const now = nowString ? dayjs(nowString) : dayjs();

  return Math.abs(dayjs(date).diff(now, 'day'));
}
